// AUTO-GENERATED by scripts/gen-doc-meta.cjs.
// Do not edit by hand — update frontmatter datePublished/dateModified
// in the relevant doc under pages/ and re-run `pnpm gen:dates`.

export interface DocDates {
  datePublished: string;
  dateModified: string;
}

export const DOC_DATES: Record<string, DocDates> = {
  "/": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/about": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/ai-agents/designing-mcp-servers-that-protect-secrets": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/ai-agents/how-ai-assistants-expose-keys": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/ai-agents/key-leakage-vectors-in-agent-workflows": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/ai-agents/least-privilege-keys-for-agents": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/ai-agents/oauth-vs-api-keys-for-agents": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/ai-agents/securing-keys-in-mcp-configs": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/architecture/build-vs-buy": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/architecture/edge-authentication": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/architecture/gateway-based-authentication": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/architecture/multi-service-authentication": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/best-practices/for-consumers": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/best-practices/for-providers": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/implementation/key-formats-and-prefixes": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/implementation/key-generation": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/implementation/validation-and-lookup": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/introduction/api-keys-vs-other-auth": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/introduction/getting-started": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/introduction/how-api-keys-work": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/introduction/when-to-use-api-keys": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/operations/api-monetization": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/operations/developer-portals": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/operations/key-management-at-scale": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/operations/logging-and-monitoring": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/operations/migration-strategies": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/reference/glossary": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/security/expiration-policies": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/security/hashing-and-storage": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/security/key-rotation": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/security/leak-detection": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/security/rate-limiting": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/security/revocation": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  },
  "/docs/security/scoping-and-permissions": {
    "datePublished": "2026-04-22",
    "dateModified": "2026-04-22"
  }
};
